import API from './API.ts'

export default {
  //
  // GET
  //
  getFailedSyncs ({ requestId, showAll, includeActionRequired, includeAssigned, includeRejected, onlyCategoryChanged, channelIds, searchString, offset, limit }) {
    return API.httpClient.get('bookvisit/failed-syncs', {
      params: {
        request_id: requestId,
        show_all: showAll,
        include_action_required: includeActionRequired,
        include_assigned: includeAssigned,
        include_rejected: includeRejected,
        only_category_changed: onlyCategoryChanged,
        channel_ids: channelIds,
        search_string: searchString,
        offset,
        limit
      }
    })
  },
  getFailedSync ({ failedSyncId }) {
    return API.httpClient.get(`bookvisit/failed-syncs/${failedSyncId}`)
  },
  getUnresolvedFailedSyncs () {
    return API.httpClient.get('bookvisit/failed-syncs/unresolved')
  },
  getFailedSyncAvailability ({ failedSyncId }) {
    return API.httpClient.get(`bookvisit/failed-syncs/${failedSyncId}/availability`)
  },

  //
  // POST
  //
  updateFailedSync ({ failedSyncId, notes }) {
    return API.httpClient.post(`bookvisit/failed-syncs/${failedSyncId}/update`, {
      notes
    })
  },
  retryFailedSync ({ failedSyncId, positionId, positionAssignments, overrideGuestCapacity }) {
    return API.httpClient.post(`bookvisit/failed-syncs/${failedSyncId}/retry`, {
      position_id: positionId,
      position_assignments: positionAssignments,
      override_guest_capacity: overrideGuestCapacity
    })
  },
  rejectFailedSync ({ failedSyncId, notes }) {
    return API.httpClient.post(`bookvisit/failed-syncs/${failedSyncId}/reject`, {
      notes
    })
  },
  undoRejectFailedSync ({ failedSyncId }) {
    return API.httpClient.post(`bookvisit/failed-syncs/${failedSyncId}/undo-reject`)
  }
}
